







import Vue from 'vue';
import type { PropOptions } from 'vue';
import CommissionIcon from './images/commission-icon.vue.svg';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardCommission',
  components: {
    CommissionIcon,
  },
  props: {
    value: {
      type: Number,
      default: null,
      required: true,
    } as PropOptions<number>,
  },
});
